import { getCountry, getBrand } from '@/utils/index';
import Api from '@/api/index';
import { setLocalStorage } from '@/utils/localStorage';
const state = {
  isH5: false, // 是否是手机端
  country: getCountry(),
  brand: getBrand(),
  token: '',
  uid: '',
  openTimeObj: {
    isOpen: true,
    tip: '',
  },
  isAccountLoading: true,
  enums: {},
};
const mutations = {
  setIsH5State(state, data) {
    state.isH5 = data;
  },
  setGlobalParams(state, data) {
    state.globalParams = data.data;
  },
  setOpenTime(state, data) {
    state.openTimeObj = data;
  },
  updateEnums(state, data) {
    state.enums = data;
  },
  updateAccountLoading(state, data) {
    state.isAccountLoading = data;
  },
};
const actions = {
  setIsH5({ commit }, param) {
    commit('setIsH5State', param);
  },
  async getCheckOpenTime({ commit }, params) {
    let res = await Api.checkOpenTime(params);
    res && commit('setOpenTime', res);
    return res;
  },
  /**
   * @description: 获取token
   * @param {type}
   * @return
   */
  async getToken({ commit, state }, params) {
    let res = {};
    try {
      res = await Api.getToken(params);
      setLocalStorage('ticket', res?.token);
      setLocalStorage('uid', res?.uid);
      state.token = res?.token;
      state.uid = res?.uid;
    } catch (e) {
      return false;
    }
    return res;
  },
  async getEnums({ commit }, params) {
    const data = await Api.getEnums(params);
    data && commit('updateEnums', data);
    commit('updateAccountLoading', false);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
